
const INITIAL_STATE = {}

const cadastroReducer = (state = INITIAL_STATE, action) => {
        switch (action.type) {
                case "GET_DATA_USUARIO":
                        return { ...state, listaDadosTodos: action.payload.data }
                // case "GET_DATA_USUARIO_FILTRO":
                //         return { ...state, listaDados: action.payload.data }
                case "GET_CAMPOS_BRK":
                        return { ...state, vetorCmpBrk: action.payload.data }
                case "GET_CAMPOS_USU":
                        return { ...state, vetorCmpUsu: action.payload.data }
                case "GET_DATA_EXISTE_EMAIL":
                        return { ...state, RedExisteEmail: action.payload.data }
                case "GETDTACSDOEMAILCAD":
                        return { ...state, vetorCadCmpEmailAcs: action.payload.data };

                default:
                        return state
        }
}
export default cadastroReducer;
